export enum NotesComponentLocators {
	deleteModalCanelButton = 'deleteModalCanelButton',
	deleteModalConfirmButton = 'deleteModalConfirmButton',
	notesCreateButton = 'notesCreateButton',
	notesSearchField = 'notesSearchField',
	notesSerchIconButton = 'notesSearchIconButton',
}
